import React, { useEffect } from 'react';
import { ErrorLayout, MainLayout } from '@layouts';
import { useDispatch } from 'react-redux';
import { withUser } from '@modules/auth';
import { getBlog } from '@modules/get-data';
import { PROCESSING_ITEMS } from '@constants';
import { BlogPage } from '@sections/Blog-Page';
import { BLOG_CATEGORIES } from '@constants';
import { getErrorContent } from '@libs';
import { ErrorStub } from '@components/Error-Stub';
import * as actions from '@store/actions';

const Blog = ({ articles, navigations, pageCount, currentCategory, statusCode }) => {
  return (
    <BlogPage articles={articles} navigations={navigations} pageCount={pageCount} currentCategory={currentCategory} />
  );
};

Blog.getLayout = (page, { currentCategory, statusCode }) => {
  const { translations } = page.props;

  if (statusCode) {
    const error = getErrorContent({ code: statusCode });

    return (
      <ErrorLayout title={translations.t(error.title)}>
        <ErrorStub error={error} />
      </ErrorLayout>
    );
  }

  return (
    <MainLayout
      title={`${translations.t(`site.blog.title.${[currentCategory]}`)} | Planoplan Blog`}
      processing={PROCESSING_ITEMS.GET_BLOG}
      description={translations.t(`site.blog.description.${[currentCategory]}`)}
      keywords={translations.t(`site.blog.keywords.${[currentCategory]}`)}>
      {page}
    </MainLayout>
  );
};

Blog.getInitialProps = async ({ res, query, store }) => {
  const { category = [] } = query;
  store.dispatch(actions.clearError('GET_BLOG'));

  const isNotAvailableCategory = category.length > 0 && !Object.values(BLOG_CATEGORIES).includes(category[0]);

  if (isNotAvailableCategory) {
    if (res) {
      res.statusCode = 404;
    }
    return { statusCode: 404 };
  }

  const { dispatch } = store;
  const blogData = await dispatch(getBlog(query));
  return { ...blogData, statusCode: undefined };
};

export default withUser(Blog);
